import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AuthService } from './auth.service';
import {GlobalVariable} from './../global';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  private baseUrl: string = GlobalVariable.BASE_URL;
  private customersCache$: Observable<any> | null = null;
  constructor(private http: HttpClient, private auth: AuthService) { }

  getBranches() {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/branch/getbranches';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getCustomers() {
    if (!this.customersCache$) {
      const apiKey = this.auth.getToken();
      const apiUrl = this.baseUrl + '/customer/getcustomers';
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiKey}`
      };
      this.customersCache$ = this.http.get<any>(apiUrl, { headers }).pipe(
        shareReplay(1)
      );
    }
    return this.customersCache$;
  }
  getCustomersByBranch(branchID: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/customer/getcustomers?branchId='+branchID;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }

  getAssociatesList(filterObj: any) {
    console.log(filterObj.weekEndingDate);
    let endDate = filterObj.weekEndingDate;
    let companyId = filterObj.companyId;
    let departmentId = filterObj.departmentId;
    
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/timesheetsummary/summaryadmin?weekEndingDate='+endDate+'&companyId='+companyId+'&departmentId='+departmentId;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
    
  }

  // getAssociatesList(filter: { weekEndingDate: string; companyId: string; departmentId: string }) {
  //   const { weekEndingDate, companyId, departmentId } = filter;

  //   const apiUrl = `${this.baseUrl}TimesheetSummary/summary-grouped-by-company`;
  //   const params = new HttpParams()
  //     .set('weekEndingDate', weekEndingDate)
  //     .set('companyId', companyId)
  //     .set('departmentId', departmentId);

  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${this.auth.getToken()}`
  //   });

  //   return this.http.get<any>(apiUrl, { headers, params });
  // }

  getCompanyList(filter: { weekEndingDate: string; companyId: string; departmentId: string }) {
    const { weekEndingDate, companyId, departmentId } = filter;

    const apiUrl = `${this.baseUrl}/TimesheetSummary/summary-grouped-by-company`;
    const params = new HttpParams()
      .set('weekEndingDate', weekEndingDate)
      .set('companyId', companyId)
      .set('departmentId', departmentId);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.auth.getToken()}`
    });

    return this.http.get<any>(apiUrl, { headers, params });  
    
  }

  getCompanySection(filter: { 
    weekEndingDate: string; 
    companyId: string; 
    departmentId: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortOrder?: string;
  }) {
    const { weekEndingDate, companyId, departmentId, page, pageSize, sortBy, sortOrder } = filter;

    const apiUrl = `${this.baseUrl}/TimesheetSummary/summary-grouped-by-companySection`;
    let params = new HttpParams()
      .set('weekEndingDate', weekEndingDate)
      .set('companyId', companyId)
      .set('departmentId', departmentId);

    // ページングパラメータを追加（オプショナル）
    if (page !== undefined && pageSize !== undefined) {
      params = params.set('page', page.toString()).set('pageSize', pageSize.toString());
    }
    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }
    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.auth.getToken()}`
    });

    return this.http.get<any>(apiUrl, { headers, params });
  }
  
  getAssociatesByCompany(filter: { 
    weekEndingDate: string; 
    companyId: string; 
    departmentId: string; 
    sectionId?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortOrder?: string;
  }) {
    const { weekEndingDate, companyId, departmentId, sectionId, page, pageSize, sortBy, sortOrder } = filter;

    const apiUrl = `${this.baseUrl}/TimesheetSummary/summary-grouped-by-user`;
    let params = new HttpParams()
      .set('weekEndingDate', weekEndingDate)
      .set('companyId', companyId)
      .set('departmentId', departmentId)
      .set('sectionId', sectionId ?? '-1');

    // ページングパラメータを追加（オプショナル）
    if (page !== undefined && pageSize !== undefined) {
      params = params.set('page', page.toString()).set('pageSize', pageSize.toString());
    }
    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }
    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.auth.getToken()}`
    });

    return this.http.get<any>(apiUrl, { headers, params });
  }
  
  

  getAssociatesForAdmin(filter: { selectedSystemId: string; selectedCustomer: string; selectedSupplierId: string, selectedBranch: string; userType: string, selectStatus: string }) {
    const { selectedSystemId, selectedCustomer, selectedSupplierId, selectedBranch, userType, selectStatus } = filter;
    const apiKey = this.auth.getToken();
    const apiUrl = `${this.baseUrl}/User/by-approver`;
    const params = new HttpParams()
      .set('weekEndingDate', '')
      .set('enabled', selectStatus)
      .set('userType', userType)
      .set('customerId', selectedCustomer)
      .set('supplierId', selectedSupplierId)
      .set('branchId', selectedBranch)
      .set('systemId', selectedSystemId);
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers, params });
  }

  getContract(filter: { startDate: string; selectedSupplierId: string; selectedBranch: string; selectedCustomer: string;}) {
    const { startDate, selectedCustomer, selectedSupplierId, selectedBranch } = filter;
    const apiKey = this.auth.getToken();
    let apiUrl = `${this.baseUrl}/ClientJobOrder/ContractList`;
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('companyId', selectedCustomer)
      .set('supplierId', selectedSupplierId)
      .set('branchId', selectedBranch);
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers, params });
  }
  
  getGroupContract(filter: { startDate: string; selectedSupplierId: string; selectedBranch: string; selectedCustomer: string; }) {
    const { startDate, selectedCustomer, selectedSupplierId, selectedBranch } = filter;
    const apiKey = this.auth.getToken();
    let apiUrl = `${this.baseUrl}/ClientJobOrder/ContractListGrouping`;
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('companyId', selectedCustomer)
      .set('supplierId', selectedSupplierId)
      .set('branchId', selectedBranch);
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers, params });
  }
}
